import type { Context } from '../models/types'

const URL = `https://ierxexdtyashuotcsjyo.supabase.co/functions/v1/send_message_to_slack`

export const MIGRATION_ISSUES_CHANNEL_ID = 'C0684B0CUF8'

export default async function notify(
  context: Context,
  text: string,
  customChannelId?: string,
  contextData?: Record<string, string | number | boolean | null | undefined>,
  error?: { response?: { data: string }; message: string }
) {
  let message = error ? text : `Error (Backend) - ${text}`

  if (error)
    message += `: ${
      error && error.response && error.response.data
        ? JSON.stringify(error.response.data)
        : error.message
    }`
  if (contextData)
    message += `\n\n\`\`\`\n${Object.entries(contextData)
      .map(([k, v]) => `${k}: ${v}`)
      .join('\n')}\`\`\``
  const channelId = customChannelId || getChannelId(context, message)
  await context
    .fetch(URL, {
      method: 'POST',
      body: JSON.stringify({ message, channel_id: channelId }),
      headers: {
        apikey:
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImllcnhleGR0eWFzaHVvdGNzanlvIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjQ4ODU2NDIsImV4cCI6MTk4MDQ2MTY0Mn0.AbUQz18lps79WZBW1kmbFP2lUTiAF6ttTuFK14yvUuw',
        authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsImtpZCI6IklVZnFVRnhXNnZOQU0vQkQiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJhdXRoZW50aWNhdGVkIiwiZXhwIjoxNzAxNzA5MzU3LCJpYXQiOjE3MDExMDQ1NTcsImlzcyI6Imh0dHBzOi8vaWVyeGV4ZHR5YXNodW90Y3NqeW8uc3VwYWJhc2UuY28vYXV0aC92MSIsInN1YiI6ImZkNWJiOWJlLTNiOWMtNDg1Ni05ZDgxLTdhNzMxYzAyMjBhMyIsImVtYWlsIjoiamVyZW15QGhleXNhdnZ5LmNvbSIsInBob25lIjoiIiwiYXBwX21ldGFkYXRhIjp7InByb3ZpZGVyIjoiZW1haWwiLCJwcm92aWRlcnMiOlsiZW1haWwiLCJnb29nbGUiXX0sInVzZXJfbWV0YWRhdGEiOnt9LCJyb2xlIjoiYXV0aGVudGljYXRlZCIsImFhbCI6ImFhbDEiLCJhbXIiOlt7Im1ldGhvZCI6Im90cCIsInRpbWVzdGFtcCI6MTcwMDI3Mjg5MH1dLCJzZXNzaW9uX2lkIjoiMDZmYjllODgtYmFiYS00ZGFiLWI0MTAtNDIxNDMxZWE0ZDk4In0.qZRZMHlEBQ7NmZv-nhV8PIO-Tn_JbOlIV0g-_EtQiMc',
        'Content-Type': 'application/json',
      },
    })
    .then((res: Response) => {
      console.log('notify.ts called send_message_to_slack - response:', res)
    })
    .catch((err: Error) => {
      console.error('ERROR with notify.ts calling send_message_to_slack:', err)
    })
}

// deno-lint-ignore no-explicit-any
function getChannelId(context: Record<string, any> | null, message: string) {
  // if (ENV === 'Dev') return `C01527NKEF6`
  if (message.includes('Failed to fetch')) return `C0269MX9ETB`
  if (!context) return `G012HKB0XQE`
  if (context.datadump) return `C021S60JJPM`
  if (context.failedFetch) return `C0269MX9ETB`
  if (context.channel) return context.channel
  return `G012HKB0XQE`
}
